import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../IProduct';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { P00039AntenneTypeEnum } from '../../Enum/P00039AntenneTypeEnum';
import { LabelConfigurationWarningMode } from '../../../../../helper/enum/LabelConfigurationType';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';

@Component({
  selector: 'app-p00039-installation-coffret',
  templateUrl: './p00039-installation-coffret.component.html',
  styleUrls: ['./p00039-installation-coffret.component.scss'],
  standalone: true,
  imports: [
    IonFooter,
    IonButton,
    IonContent,
    HeaderConfigurationComponent,
    TranslatePipe,
    IonLabel,
    IonList,
    IonItem,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    GlobalPageHeaderComponent,
    LabelConfigurationComponent,
  ],
})
export class P00039InstallationCoffretComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039AntenneTypeEnum = P00039AntenneTypeEnum;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
